import { Schema, arrayOf } from 'normalizr'

const label = new Schema('labels', { idAttribute: 'id' });
const filteredLabel = new Schema('filteredLabels', { idAttribute: 'id' });
const labelParents = new Schema('label', { idAttribute: 'id' });
const labelDetails = new Schema('labelDetails', { idAttribute: 'id' });
const weightedLabel = new Schema('weightedLabels', { idAttribute: 'childId' });
const advertiser = new Schema('advertisers', { idAttribute: 'id' });
const classifier = new Schema('classifiers', { idAttribute: 'id' });
const entitySuggestion = new Schema('entitySuggestions', { idAttribute: 'name' });
const entityRecommendation = new Schema('entityRecommendations', { idAttribute: 'name' });
const entitiesWebPage = new Schema('entitiesWebPages', { idAttribute: 'id' });
const classifierDetail = new Schema('classifierDetail', { idAttribute: 'id' });
const clfTarget = new Schema('clfTarget', { idAttribute: 'id' });
const savedWeightedTarget = new Schema('savedWeightedTarget', {idAttribute: savedWeightedTargetId});
const savedMTurkEvaluator = new Schema('savedMTurkEvaluator', {idAttribute: savedMTurkEvaluatorId});
const savedTurkQaEnabled = new Schema('savedTurkQaEnabled', {idAttribute: savedTurkQaEnabledId});
const savedNewClassifier = new Schema('savedNewClassifier', {idAttribute: savedNewClassifierId});
const textDetectorResult = new Schema('textDetectorResults', { idAttribute: 'pageId' });
const videoDetectorResult = new Schema('videoDetectorResults', { idAttribute: 'videoId' })
const boxDetectorResult = new Schema('boxDetectorResults', { idAttribute: 'boxId' })
const turkQaEnabled = new Schema('turkQaEnabled', {idAttribute: 'id'});
const mturkEvaluator = new Schema('mturkEvaluator', {idAttribute: 'id'});
const classifiersAccess = new Schema('classifiersAccess', {idAttribute: 'id'});
const entityRecommenderAccess = new Schema('entityRecommenderAccess', {idAttribute: 'id'});

const user = new Schema('user', {idAttribute: 'email'});

function savedWeightedTargetId(entity) {
  if (!!entity.weightedClfTarget) {
    return entity.weightedClfTarget.clfTargetId;
  } else {
    return entity.okay;
  }
}

function savedMTurkEvaluatorId(entity) {
  return entity.mturkEvaluator.id;
}

function savedTurkQaEnabledId(entity) {
  return entity.classifierTarget.id;
}

function savedNewClassifierId(entity) {
  return entity.classifier.name;
}


label.define({
  weightedLabels: arrayOf(weightedLabel)
});

weightedLabel.define({
  childLabel: label
})

export default {
  label,
  labelParents,
  labelDetails,
  labels: arrayOf(label),
  filteredLabel,
  filteredLabels: arrayOf(filteredLabel),
  advertiser,
  advertisers: arrayOf(advertiser),
  classifier,
  classifierDetail,
  classifiers: arrayOf(classifier),
  clfTarget,
  weightedLabel,
  weightedLabels: arrayOf(weightedLabel),
  entitySuggestion,
  entitySuggestions: arrayOf(entitySuggestion),
  entityRecommendation,
  entityRecommendations: arrayOf(entityRecommendation),
  entitiesWebPage,
  entitiesWebPages: arrayOf(entitiesWebPage),
  savedWeightedTarget,
  textDetectorResult,
  textDetectorResults: arrayOf(textDetectorResult),
  videoDetectorResult,
  videoDetectorResults: arrayOf(videoDetectorResult),
  boxDetectorResult,
  boxDetectorResults: arrayOf(boxDetectorResult),
  turkQaEnabled,
  mturkEvaluator,
  savedMTurkEvaluator,
  savedTurkQaEnabled,
  savedNewClassifier,
  classifiersAccess,
  entityRecommenderAccess,
  user
}



// WEBPACK FOOTER //
// ./src/schemas/index.js